import { withInstall } from '@fx-front-framework/utils/with-install'
import PageTableV2 from './src/page-table-v2.vue'

export const FxPageTableV2 = withInstall(PageTableV2)
export default FxPageTableV2

export * from './src/types'
